import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH4Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "numberedCard",
  props: {
    number: {
      id: uuidv4(),
      type: "string",
      prop: "other",
      value: "1",
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createH4Block({
          text: "Apply",
        }),
        createPBlock({
          text: "Complete a brief application to ensure we're the right fit for each other.",
        }),
      ],
    },
  },
};
